import { cn } from "@utils/Cn";

const Collapse = ({ children }) => {

  return <div className="rounded-xl ring-inset ring-1 ring-zinc-200">{children}</div>
}

const CollapseItem = ({ isOpen, onClick, label, children, top, bottom }) => <div className="">
  <button
    onClick={onClick}
    className={cn(
      "flex items-center h-14 w-full py-4 px-3 gap-4 cursor-pointer",
      top && "rounded-t-xl",
      isOpen && "bg-primary-50 border border-primary-300"
    )}
  >
    <Radio selected={isOpen} />
    <span className="font-medium">{label}</span>
  </button>
    <div
      className={cn(
        "px-4 overflow-hidden bg-zinc-100 transition-all duration-300",
        isOpen ? "py-5" : "h-0 py-0",
        bottom && "rounded-b-xl"
      )}
    >
    {children}
  </div>
</div>

const Radio = ({ selected }) => <div className={cn(
  "size-4 rounded-full ring-[1px] ring-inset ring-zinc-300 flex items-center justify-center",
  selected && "ring-primary-500"
)}>
  {selected && <div className="size-3 bg-primary-500 rounded-full"></div>}
</div>

export {
  Collapse,
  CollapseItem
};
